/**
 * Price-drop subscription block on the public product page.
 */
import { useState } from "react";
import axios from "axios";
import { Check, EnvelopeSimple, PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { BACKEND } from "@/components/public/shared";

export function SubscribeBlock({ productId, negocio }) {
  const [email, setEmail] = useState("");
  const [nombre, setNombre] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(() => {
    try {
      return !!localStorage.getItem("vendeia_sub");
    } catch {
      return false;
    }
  });

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Tu email es obligatorio");
    setBusy(true);
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref") || null;
      await axios.post(`${BACKEND}/api/subscribers`, {
        email: email.trim().toLowerCase(),
        nombre: nombre.trim(),
        source_product_id: productId,
        source_referral_code: ref,
      });
      try {
        localStorage.setItem("vendeia_sub", JSON.stringify({ email, at: Date.now() }));
      } catch {
        // localStorage may be unavailable (Safari private mode → quota 0).
        // The subscription is already persisted server-side; the local copy
        // is a UX nicety, not critical.
      }
      setDone(true);
      toast.success("¡Te suscribiste! Recibirás novedades pronto.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo registrar");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="border border-[#00C853] bg-[#E8F5E9] p-6 flex items-start gap-3" data-testid="subscribe-done">
        <Check size={22} className="text-[#1B5E20] shrink-0 mt-0.5" weight="bold" />
        <div>
          <div className="h-display text-xl font-bold text-[#1B5E20]">¡Estás dentro!</div>
          <p className="text-sm text-[#1B5E20]/80 mt-1">
            Te avisaremos cuando {negocio?.nombre || "la tienda"} publique nuevos productos como este.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-center" data-testid="subscribe-block">
      <div className="md:col-span-5">
        <div className="overline text-klein flex items-center gap-1.5">
          <EnvelopeSimple size={12} weight="fill" /> Lista privada
        </div>
        <h3 className="h-display text-2xl md:text-3xl font-black tracking-tighter mt-2">
          Sé el primero en
          <br />
          <span className="text-klein">enterarte.</span>
        </h3>
        <p className="text-sm text-muted2 mt-2 leading-relaxed">
          Recibe nuevos productos y promos directo a tu correo. Sin spam. Cancela cuando quieras.
        </p>
      </div>
      <form className="md:col-span-7 grid grid-cols-1 sm:grid-cols-12 gap-2" onSubmit={submit}>
        <input
          className="input-flat sm:col-span-4"
          placeholder="Tu nombre (opcional)"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          data-testid="sub-name"
        />
        <input
          type="email"
          required
          className="input-flat sm:col-span-5"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="sub-email"
        />
        <button
          type="submit"
          disabled={busy}
          className="sm:col-span-3 inline-flex items-center justify-center gap-2 px-4 py-2 bg-klein text-white text-sm font-semibold hover:bg-klein-dark disabled:opacity-50"
          data-testid="sub-submit"
        >
          {busy ? "…" : (
            <>
              <PaperPlaneTilt size={14} weight="fill" /> Suscribirme
            </>
          )}
        </button>
      </form>
    </div>
  );
}
